module.exports = __webpack_public_path__ + "img/share.4b7b021a.svg";